import React, { useState } from 'react';
import { doc, setDoc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * QueueSaveControls
 * Encapsulates the save-to-Firestore behavior for selected queue SIDs.
 *
 * Props:
 * - userId: string (required)
 * - selectedSids: string[] (required)
 * - onSaved?: (message: string) => void  // callback to show a toast/message in parent
 * - className?: string // optional for styling the button
 * - label?: string // button label when idle (default: 'Opslaan')
 */
export default function QueueSaveControls({ userId, selectedSids, onSaved, className, label = 'Opslaan' }) {
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!userId) return;
    setSaving(true);
    try {
      // Read existing saved SIDs from subcollection
      const savedSnapshot = await getDocs(collection(db, 'users', userId, 'savedTaskqueues'));
      const savedSids = savedSnapshot.docs.map(doc => doc.id);

      const toAdd = (selectedSids || []).filter(sid => !savedSids.includes(sid));
      const toDelete = savedSids.filter(sid => !(selectedSids || []).includes(sid));

      const addPromises = toAdd.map(sid => setDoc(doc(db, 'users', userId, 'savedTaskqueues', sid), { selected: true }));
      const deletePromises = toDelete.map(sid => deleteDoc(doc(db, 'users', userId, 'savedTaskqueues', sid)));

      await Promise.all([...addPromises, ...deletePromises]);

      onSaved?.('Queues successvol opgeslagen!');
    } catch (err) {
      console.error('Error bij het opslaan van Queues', err);
      onSaved?.('Error bij het opslaan van Queues');
    } finally {
      setSaving(false);
    }
  };

  return (
    <button type="button" className={className} disabled={!userId || saving} onClick={save}>
      {saving ? 'Opslaan...' : label}
    </button>
  );
}
